import { AddressFields, type AddressFormState } from "./AddressFields";

export type KarigarPlace = Omit<AddressFormState, "gstNumber">;

export function KarigarPlaceFields({ value, onChange, errors = {}, language = "en", addressRequired = false }: {
  value: KarigarPlace;
  onChange: (patch: Partial<KarigarPlace>) => void;
  errors?: Record<string, string>;
  language?: "en" | "hi";
  addressRequired?: boolean;
}) {
  return <AddressFields value={{ ...value, gstNumber: "" }} errors={errors}
    onChange={onChange} required pincodeRequired showGst={false} language={language} addressRequired={addressRequired} />;
}
